const de = {
  vacation: {
    vacationTimes: 'Urlaubszeiten',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    alerts: {
      failedDelete: 'Der Urlaub konnte nicht gelöscht werden.',
      failedUpdate: 'Der Urlaub konnte nicht bearbeitet werden.',
      failedCreate: 'Der Urlaub konnte nicht angelegt werden.',
      successfulCreate: 'Der Urlaub wurde erfolgreich angelegt.',
      successfulUpdate: 'Der Urlaub wurde erfolgreich bearbeitet.',
      successfulDelete: 'Der Urlaub wurde erfolgreich gelöscht.',
      vacationSaveSuccessful: 'Der Urlaub wurde erfolgreich angelegt.',
      loadError: 'Die Urlaube konnten nicht geladen werden.'
    },
    conflictingBookings:
      'Es gibt bereits Buchungen im ausgewählten Zeitraum. Bitte kümmere dich um die folgenden Buchungen:',
    confirmDelete: 'Möchten Sie den Urlaub wirklich löschen?',
    ColorDescription: {
      vacation: 'Urlaub',
      booking: 'Buchung',
      vacationBooking: 'Urlaub und Buchung'
    }
  },
  lendertimes: {
    availabilityTimes: {
      title: 'Abhol- und Rückgabezeiten',
      text1:
        'Geben Sie an, wann jemand standardmäßig verfügbar ist, um ein Produkt auszugeben oder entgegenzunehmen.',
      text2:
        'Diese Zeiten können in einzelnen Produkten im Bereich "Verfügbare Zeiträume" mit dem Schieberegler "Unabhängig von Abhol-/Rückgabezeiten des Verleihers" überschrieben werden.',
      text3:
        'Bitte beachten Sie, dass bei Überlappungen der Zeiträume immer das größere Intervall berücksichtigt wird.'
    },
    noLenderTimeAvailable:
      'Im Moment sind noch keine Öffnungszeiten hinterlegt. Bitte legen sie hier Ihre erste an: ',
    alerts: {
      failedUpdate: 'Die Öffnungszeiten konnten nicht bearbeitet werden.',
      successfulUpdate: 'Die Öffnungszeiten wurden erfolgreich bearbeitet.'
    }
  }
};

export default de;
export type LeihbarOpeningHoursSettingsTranslation = typeof de;
